var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabIconCustomerDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.731,
    height: 33.69,
    viewBox: "0 0 32.731 33.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Uppgifter",
    transform: "translate(-20.281 -20.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715",
    transform: "translate(21.231 21.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24319",
    "data-name": "Path 24319",
    d: "M40.566,32.146a9.578,9.578,0,1,0,9.184,9.565A9.381,9.381,0,0,0,40.566,32.146Z",
    transform: "translate(-25.151 -25.821)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24320",
    "data-name": "Path 24320",
    d: "M38.787,21.842h0a3.315,3.315,0,0,0,5.246,1.747h0L47.5,26.167h0a3.412,3.412,0,0,0,3.243,4.572h0l1.323,4.172h0a3.473,3.473,0,0,0,0,5.652h0l-1.323,4.172h0A3.412,3.412,0,0,0,47.5,49.307h0l-3.464,2.579h0a3.315,3.315,0,0,0-5.246,1.746H34.506a3.314,3.314,0,0,0-5.246-1.746h0L25.8,49.307h0a3.412,3.412,0,0,0-3.243-4.572h0l-1.323-4.172h0a3.474,3.474,0,0,0,0-5.652h0l1.323-4.172h0A3.412,3.412,0,0,0,25.8,26.167h0l3.464-2.578h0a3.314,3.314,0,0,0,5.246-1.747h4.281Z",
    transform: "translate(-21.231 -21.842)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716",
    transform: "translate(30.207 31.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24321",
    "data-name": "Path 24321",
    d: "M35.852,53.889A6.444,6.444,0,0,1,42.29,47.7a6.444,6.444,0,0,1,6.438,6.2",
    transform: "translate(-35.852 -40.818)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_635",
    "data-name": "Ellipse 635",
    cx: 2.769,
    cy: 2.769,
    r: 2.769,
    transform: "translate(3.67 0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconCustomerDetails);
export default __webpack_public_path__ + "static/media/TabIcon_CustomerDetails.0cea4c0f3058e647d9648fa4910663d7.svg";
export { ForwardRef as ReactComponent };